import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchErr, showInputError } from 'src/app/shared/utils';
import { Dio } from '../../dio.model';
import { AfericaoService } from '../../afericao.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AprovarDto } from '../aprovar.dto';
import { DioService } from '../../dio.service';
import dayjs from 'dayjs';
import { RegraCorteAfericao, RegrasCortesAfericoesService } from 'src/app/config/regras-cortes-afericao/regras-cortes-afericoes.service';
import { RegistrarApontamentoDto } from './registrar-apontamento.dto';

@Component({
    selector: 'app-registrar-apontamento',
    templateUrl: './registrar-apontamento.component.html',
    styleUrls: ['./registrar-apontamento.component.css'],
    standalone: false
})
export class RegistrarApontamentoComponent implements OnInit {

    loading: boolean;
    cancelTotal: boolean
    cancelData: RegistrarApontamentoDto;
    idDio: string | undefined;
    showInputError = showInputError;
    afericaoId: string;
    aprovarCtx: boolean;
    regrasCortes: RegraCorteAfericao[];
    regraCorteSelecionada: RegraCorteAfericao;

    dio: Dio;
    tipoEquipamento: string;

    // Opções base de tipo de desconto
    private tiposDescontoBase = [
        { value: 'HORA_DISPONIVEL', label: 'HORA DISPONÍVEL' },
        { value: 'KM_RODADOS', label: 'KM RODADO' },
        { value: 'HORA_TRABALHADA', label: 'HORA TRABALHADA' }
    ];

    // Getter que retorna as opções filtradas baseadas no tipo de equipamento
    get tiposDesconto() {
        return this.tiposDescontoBase.filter(tipo => {
            const tipoEquipamentoUpper = this.tipoEquipamento?.toUpperCase() || '';
            
            // Remove HORA_TRABALHADA se for VEICULO/VEICULOS
            if ((tipoEquipamentoUpper === 'VEICULO' || tipoEquipamentoUpper === 'VEICULOS') && tipo.value === 'HORA_TRABALHADA') {
                return false;
            }
            // Remove KM_RODADOS se for MAQUINA/MAQUINAS
            if ((tipoEquipamentoUpper === 'MAQUINA' || tipoEquipamentoUpper === 'MAQUINAS') && tipo.value === 'KM_RODADOS') {
                return false;
            }
            return true;
        });
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { dio: Dio, cancelTotal: boolean, aprovarCtx: boolean },
        public dialogRef: MatDialogRef<RegistrarApontamentoComponent>,
        private afericaoService: AfericaoService,
        private regrasCortesService: RegrasCortesAfericoesService,
        private dioService: DioService,
        private snackBar: MatSnackBar
    ) {
        this.dio = data?.dio;        
        this.tipoEquipamento = data?.dio?.alocacao?.equipamento?.grupo.tarifacoes;

        console.log('dio ao registrar apontamento: ', this.dio);                
        console.log('tipoEquipamento: ', this.tipoEquipamento);
        console.log('tipos desconto filtrados: ', this.tiposDesconto);

        this.idDio = data?.dio?.id;
        this.cancelTotal = data.cancelTotal;
        this.aprovarCtx = data.aprovarCtx;
    }    
    
    ngOnInit() {
        this.cancelData = new RegistrarApontamentoDto();
        this.loading = true;
        this.cancelTotal = this.data.cancelTotal

        this.regrasCortesService.getRegrasAfericoes().subscribe({
            next: (res) => this.regrasCortes = res,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    filesOut($event: any) {
        this.cancelData.imagens = $event;
    }

    fileRemove($event: { file: any, index: number }) {
        this.cancelData.imagens.splice($event.index, 1);
    }

    checkDioFinishSameDay() {
        return dayjs(this.data.dio.dataInicioExecucao).isSame(this.data.dio.dataFimExecucao, 'day')
    }

    cancelDio() {
        this.loading = true;

        if (this.aprovarCtx) {
            this.aprovar();
            return;
        }


        if (this.cancelTotal) {
            this.totalCancelation();
            return;
        }

        this.parcialCancelation();
    }

    totalCancelation() {
        const createCorte = {
            dataInicio: this.data.dio?.dataInicioExecucao,
            dataFim: this.data.dio?.dataFimExecucao,
            motivo: this.cancelData?.motivo,
            afericaoId: this?.data?.dio?.afericao.id,
            isTotalCancelation: this.cancelTotal || true,
            isCorteTotal: true,
        };

        const imagens = this.cancelData.imagens

        this.afericaoService.createCorteParcialTotal({
            ...createCorte,
            imagens
        }).subscribe({
            next: (res) => {
                this.afericaoService.finishAfericao(this.idDio || "", {
                    ...createCorte,
                    isCorteTotal: true
                }).subscribe({
                    next: (res) => {
                        this.snackBar.open('Aferição cancelada com sucesso!', 'OK', { duration: 5000 });
                        this.loading = false;
                        this.dioService.notifygetMetricsSubject();
                        this.dialogRef.close(true);
                    },
                    error: (err) => {
                        this.loading = false;
                        catchErr(err, this.snackBar)
                    }
                });
            },
            error: (err) => {
                this.loading = false;
                catchErr(err, this.snackBar)
            }
        });
    }

    diabledCancelationButton() {
        if (this.cancelTotal) {
            return this.loading || !this.cancelData.regras;
        }

        const startDateInvalid = !this.cancelData.dateStart || this.cancelData.dateStart == undefined;
        const startHourInvalid = !this.cancelData.hourStart || this.cancelData.hourStart == undefined;

        const endDateInvalid = !this.cancelData.dateEnd || this.cancelData.dateEnd == undefined;
        const endHourInvalid = !this.cancelData.hourEnd || this.cancelData.hourEnd == undefined;

        if (this.checkDioFinishSameDay()) {
            return this.loading ||
                startHourInvalid ||
                endHourInvalid ||
                !this.cancelData.regras;
        }

        return this.loading ||
            startDateInvalid ||
            startHourInvalid ||
            endDateInvalid ||
            endHourInvalid ||
            !this.cancelData.regras;
    }

    parcialCancelation() {
        const formatHourInicio = this.cancelData?.hourStart.slice(0, 2) + ":" + this.cancelData?.hourStart.slice(2) + ":00";
        const formatHourFim = this.cancelData?.hourEnd.slice(0, 2) + ":" + this.cancelData?.hourEnd.slice(2) + ":00";

        let dataInicio = dayjs(this.cancelData.dateStart).format('YYYY-MM-DD') + "T" + formatHourInicio;
        let dataFim = dayjs(this.cancelData.dateEnd).format('YYYY-MM-DD') + "T" + formatHourFim;

        if (this.checkDioFinishSameDay()) {
            const dataInicioRaw = this.data.dio?.dataInicioExecucao?.toString().split('T')[0];
            const dataFimRaw = this.data.dio?.dataFimExecucao?.toString().split('T')[0];
            dataInicio = dataInicioRaw + "T" + formatHourInicio;
            dataFim = dataFimRaw + "T" + formatHourFim;
        }

        if(this.cancelData && this.cancelData.regras && this.cancelData.regras.length == 1){
            this.cancelData.regras.push("."); //contornar problema ao enviar array apenas com 1 elemento com content-type form-data
        }

        const createApontamento = {
            dataInicio,
            dataFim,
            motivo: this.cancelData?.motivo ? this.cancelData.motivo : '',
            regras: this.cancelData?.regras,
            dioId: this?.data?.dio?.id,
            isTotalCancelation: this.cancelTotal || true,
            tipoDesconto: this.cancelData?.tipoDesconto
        };

        console.log('criando apontamento: ', createApontamento);

        const imagens = this.cancelData.imagens

        this.afericaoService.createApontamento({
            ...createApontamento,
            imagens
        }).subscribe({
            next: (res) => {
                this.loading = false;
                this.dioService.notifygetMetricsSubject();
                this.dialogRef.close(true);
            },
            error: (err) => {
                this.loading = false;
                catchErr(err, this.snackBar)
            }
        });
    }

    aprovar() {
        const aprovarDto: AprovarDto = {
            isCorteTotal: true,
            motivo: this.cancelData?.motivo,
        };

        this.afericaoService.aprovar(this.idDio || '', aprovarDto).subscribe({
            next: (res) => {
                this.snackBar.open('Aferição Recusada com sucesso', '✓', { panelClass: 'success' });
                this.dioService.notifygetMetricsSubject();
                this.dialogRef.close(true);
            }, error: (err) => {
                catchErr(err, this.snackBar)
                this.dialogRef.close(true);
            }
        });
    }

    searchFn(term: string, item: any) {
        term = term?.toLocaleLowerCase();
        return item?.nome?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.titulo?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.firstName?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.lastName?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.codigo && item?.codigo.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.equipamento && item?.equipamento.toLocaleLowerCase().indexOf(term) > -1;
    }

    setRegraCorte(regraCorte: RegraCorteAfericao) {
        this.regraCorteSelecionada = regraCorte;
    }

    compareWith(item: any, selected: any) {
        return item.id == selected
    }

    removerRegra(index: number) {
        this.cancelData.regras.splice(index, 1);
        console.log('Regra removida. Regras atualizadas: ', this.cancelData);
    }

    addRegra(){
        console.log('regraSelecionada: ', this.regraCorteSelecionada);

        // Inicializa o array de regras se não existir
        if (!this.cancelData.regras) {
            this.cancelData.regras = [];
        }

        // Verifica se a regra já existe no array, comparando pelo id
        const regraExiste = this.cancelData.regras.some((regra: string) => regra === this.regraCorteSelecionada.nome);

        if (regraExiste) {
            console.log('A regra já existe e não será adicionada.');
        } else {
            // Adiciona a regra se ela não for duplicada
            this.cancelData.regras.push(this.regraCorteSelecionada.nome);
            console.log('Regras atualizadas: ', this.cancelData);
        }
    }

    onHourStartChange(newStartValue: string) {
        if(newStartValue.length === 4){
            console.log('Hour Start changed to: ', newStartValue);        
        }
    }

    onHourEndChange(newEndValue: string) {
        if(newEndValue.length === 4){
            console.log('Hour End changed to: ', newEndValue);        
        }
    }

    closeDialog() {
        // Fecha o diálogo sem passar nenhum valor de resultado
        this.dialogRef.close(false);
    }
}
